import React from "react"

export default function NotFound() {
  return (
    <>
      <h1>Page Not Found</h1>
      <p>Oops, we couldn't find this page!</p>
    </>
  )
}